import { render, staticRenderFns } from "./VisitAnswers.vue?vue&type=template&id=fc43aeb0&scoped=true&"
import script from "./VisitAnswers.vue?vue&type=script&lang=js&"
export * from "./VisitAnswers.vue?vue&type=script&lang=js&"
import style0 from "./VisitAnswers.vue?vue&type=style&index=0&id=fc43aeb0&prod&style=scss&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fc43aeb0",
  null
  
)

export default component.exports